import React from 'react'
import Footer from '../../COMPONENTS/Footer/Footer'
import { useState, useEffect } from 'react';
import Loading from '../../COMPONENTS/Loading/Loading'
import BackImage from './BackImage';
import cafe from '../../../ASSETS/tourisme/Image/image_restaurants/Groupe de masques 5.png'
import resto from '../../../ASSETS/tourisme/Image/image_restaurants/Groupe de masques 6.png'
import pizza from '../../../ASSETS/tourisme/Image/image_restaurants/Groupe de masques 7.png'
import bar from '../../../ASSETS/tourisme/Image/image_restaurants/Groupe de masques 8.png'
import patisserie from '../../../ASSETS/tourisme/Image/image_restaurants/Groupe de masques 10.png'
import mario from '../../../ASSETS/tourisme/Image/mario.png'
import { VscEye } from "react-icons/vsc";
import quenns from '../../../ASSETS/tourisme/Image/quenns.png'
import laBrise from '../../../ASSETS/tourisme/Image/laBrise.png'
import havana from '../../../ASSETS/tourisme/Image/havana.png'
import {Link} from 'react-router-dom'
import Barniere from './Barniere';
import Restau from '../../../API/tourisme/restaurant/index'
import { AnnoncesProps} from "../../../props";
import { useTranslation } from 'react-i18next';
import { ResultContext } from '../../../ResultContext';
import paradis from '../../../ASSETS/tourisme/Image/accueilHebergement.png'
import paradis2 from '../../../ASSETS/tourisme/Image/living-room-mid-century-style-with-warm-colors-ai-generative.jpg'
import paradis3 from '../../../ASSETS/tourisme/Image/luxury-bedroom-hotel.jpg'
import paradis4 from '../../../ASSETS/tourisme/Image/3d-rendering-white-wood-living-room-near-bedroom-upstair.jpg'
import {
  CarouselProvider,
  Slider,
  Slide,
  ButtonBack,
  ButtonNext,
} from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";

function Restaurant() {
    const [loading, setLoading] = useState(true);

    const [restaurant, setRestaurant] = useState<AnnoncesProps[]>([]);

    const [star, setStar] = useState('');
    const [consommation, setConsommation] = useState('');
    const [lieu, setLieu] = useState('');
    const [prix, setPrix] = useState('');
    const contexts = React.useContext(ResultContext)
    

    // Filtrer la liste des voitures en fonction des filtres
    const filteredResto = restaurant.filter((list) => {
        return (
        //(transmission === '' || list.car_transmission === transmission) &&
        //(consommation === '' || list.car_fuel_type === consommation) &&
        (lieu === '' || list.contact_address.toLowerCase().includes(lieu.toLowerCase())) &&
        (prix === '' || list.price_announce <= parseFloat(prix))
        );
    });

    let code = localStorage.getItem('code') ? localStorage.getItem('code') : localStorage.getItem('is_code');
    const getAllRestau = () => {
        Restau.getAllData(code)
        .then((res:any) => {
            //console.log(res.data);
            if (res.data.status === 200 && contexts?.results.resto === null) {
                const initialItemsArray = res.data.data.slice(0, 5);
                const shuffledInitialItems = [...initialItemsArray].sort(() => Math.random() - 0.5);
                setRestaurant(shuffledInitialItems)
            }
        })
        .catch((err:any) => {
            console.log(err);
        })
        .finally(() => {
            setLoading(false);
        })
    }

    function truncate (str : any) {
        return str.length > 200 ? str.substring(0, 200) + "..." : str;
    }

    function truncateAdress (str : any) {
        return str.length > 40 ? str.substring(0, 40) + "..." : str;
    }

    useEffect(() => {

        getAllRestau();


        //const timer = setTimeout(() => {
            // Après 5 secondes, masquer le spinner et rediriger l'utilisateur
            //setLoading(false);
        //}, 2000); // 5000 millisecondes = 5 secondes

        // Nettoyer le timer si le composant est démonté avant la fin du délai
        //return () => clearTimeout(timer);
    }, []);

     useEffect(()=>{
          if(contexts?.results.resto)
          {
            const initialItemsArray = contexts?.results.resto.slice(0, 5);
            const shuffledInitialItems = [...initialItemsArray].sort(() => Math.random() - 0.5);
            setRestaurant(shuffledInitialItems)
          }
        },[contexts?.results.resto])

  const {t} = useTranslation() as {t:(key:string)=>string}
  let authUser: { userId: number } | null = JSON.parse(localStorage.getItem('data') || 'null');

  return (
    <div>
         {loading ? (
        // Afficher le spinner tant que loading est true
        <Loading />
      ) : (
        <>
          
          <BackImage/>
          {/* Services */}
          <div className='relative flex flex-col items-center pb-10 md:mt-10 s:mt-2'>
            <div className='text-[#233D4D] text-2xl font-semibold py-10'>{t("Nos services")}</div>
              <div className=" mx-auto border-1 border-orange-500 w-[800px]">
                     <CarouselProvider
                          className="md:block hidden"
                          naturalSlideWidth={100}
                          naturalSlideHeight={100}
                          isIntrinsicHeight={true}
                          totalSlides={6}
                          visibleSlides={2}
                          step={1}
                          infinite={true}
                          isPlaying={true} // Active l'auto-slide
                          interval={3000}
                        >
                          <div className="w-full relative flex items-center justify-center">
                            <ButtonBack
                              role="button"
                              aria-label="slide backward"
                              className="absolute z-30 left-0 ml-8 focus:outline-none focus:bg-gray-400 focus:ring-2 focus:ring-offset-2 focus:ring-gray-400 cursor-pointer"
                              id="prev"
                            >
                              <svg
                                width={8}
                                height={14}
                                viewBox="0 0 8 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M7 1L1 7L7 13"
                                  stroke="white"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </ButtonBack>
                            <div className="w-full h-full mx-auto overflow-x-hidden overflow-y-hidden">
                              <Slider>
                                <div
                                  id="slider"
                                  className="h-full flex lg:gap-8 md:gap-6 gap-14 items-center justify-start transition ease-out duration-700"
                                >
                                  <Slide index={0}>
                                      <div className="flex flex-col items-center">
                                        <div className="flex flex-shrink-0 relative w-full sm:w-auto mt-3">
                                          <img className="w-[150px] bg-[#cecece] p-5" src={cafe} alt="café" />
                                        </div>
                                        <p className="text-[#FCCA46] font-semibold text-lg text-center pt-3">
                                          Cafétéria
                                        </p>
                                        <p className="w-[150px] text-center">
                                          L'arôme envoûtant du café fraîchement moulu
                                        </p>
                                      </div>
                                  </Slide>

                                  <Slide index={1}>
                                    <div className="flex flex-col items-center">
                                        <div className="flex flex-shrink-0 relative w-full sm:w-auto mt-3">
                                          <img className="w-[150px] bg-[#cecece] p-5" src={resto} alt="café" />
                                        </div>
                                        <p className="text-[#FCCA46] font-semibold text-lg text-center pt-3">
                                            Restaurant 
                                        </p>
                                        <p className="w-[150px] text-center">
                                          une expérience culinaire d'exception dans des restaurants
                                        </p>
                                    </div>
                                  </Slide>
                                  <Slide index={2}>
                                    <div className="flex flex-col items-center">
                                        <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                                          <img className="w-[150px] bg-[#cecece]" src={pizza} alt="café" />
                                        </div>
                                        <p className="text-[#FCCA46] font-semibold text-lg text-center pt-3">
                                            Pizzeria 
                                        </p>
                                        <p className="w-[150px] text-center">
                                            déguster des pizzas exquises
                                        </p>
                                    </div>
                                    
                                  </Slide>
                                  <Slide index={3}>
                                    <div className="flex flex-col items-center">
                                        <div className="flex flex-shrink-0 relative w-full sm:w-auto mt-3">
                                          <img className="w-[150px] bg-[#cecece] p-5" src={bar} alt="café" />
                                        </div>
                                        <p className="text-[#FCCA46] font-semibold text-lg text-center pt-3">
                                            Bar
                                        </p>
                                        <p className="w-[150px] text-center">
                                          des instants festifs au cœur de notre bar. Cheers
                                        </p>
                                    </div>
                                    
                                  </Slide>
                                  <Slide index={4}>
                                    <div className="flex flex-col items-center">
                                        <div className="flex flex-shrink-0 relative w-full sm:w-auto mt-3">
                                          <img className="w-[150px] bg-[#cecece] p-5" src={patisserie} alt="café" />
                                        </div>
                                        <p className="text-[#FCCA46] font-semibold text-lg text-center pt-3">
                                            Patisserie
                                        </p>
                                        <p className="w-[150px] text-center">
                                          un moment sucré dans notre pâtisserie exquise
                                        </p>
                                    </div>
                                    
                                  </Slide>
                                  <Slide index={5}>
                                    <div className="flex flex-col items-center">
                                        <div className="flex flex-shrink-0 relative w-full sm:w-auto mt-3">
                                          <img className="w-[150px] bg-[#cecece] p-5" src={cafe} alt="café" />
                                        </div>
                                        <p className="text-[#FCCA46] font-semibold text-lg text-center pt-3">
                                            Cafétéria
                                        </p>
                                        <p className="w-[150px] text-center">
                                            l'arôme envoûtant du café fraîchement moulu
                                        </p>
                                    </div>
                                    
                                  </Slide>
                                  <Slide index={0}>
                                    <div className="flex flex-col items-center">
                                        <div className="flex flex-shrink-0 relative w-full sm:w-auto mt-3">
                                          <img className="w-[150px] bg-[#cecece] p-5" src={resto} alt="café" />
                                        </div>
                                        <p className="text-[#FCCA46] font-semibold text-lg text-center pt-3">
                                            Restaurant
                                        </p>
                                        <p className="w-[150px] text-center">
                                          une expérience culinaire d'exception dans des restaurants
                                        </p>
                                    </div>
                                  
    
                                  </Slide>
                                  <Slide index={1}>
                                    <div className="flex flex-col items-center">
                                        <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                                          <img className="w-[150px] bg-[#cecece]" src={pizza} alt="café" />
                                        </div>
                                        <p className="text-[#FCCA46] font-semibold text-lg text-center pt-3">
                                            Pizzeria
                                        </p>
                                        <p className="w-[150px] text-center">
                                            déguster des pizzas exquises
                                        </p>
                                    </div>
                                    
                                  </Slide>
                                  <Slide index={2}>
                                    <div className="flex flex-col items-center">
                                        <div className="flex flex-shrink-0 relative w-full sm:w-auto mt-3">
                                          <img className="w-[150px] bg-[#cecece] p-5" src={bar} alt="café" />
                                        </div>
                                        <p className="text-[#FCCA46] font-semibold text-lg text-center pt-3">
                                            Bar
                                        </p>
                                        <p className="w-[150px] text-center">
                                            des instants festifs au cœur de notre bar. Cheers
                                        </p>
                                    </div>
                                    
                                  </Slide>
                                  <Slide index={3}>
                                    <div className="flex flex-col items-center">
                                        <div className="flex flex-shrink-0 relative w-full sm:w-auto mt-3">
                                          <img className="w-[150px] bg-[#cecece] p-5" src={patisserie} alt="café" />
                                        </div>
                                        <p className="text-[#FCCA46] font-semibold text-lg text-center pt-3">
                                            Patisserie
                                        </p>
                                        <p className="w-[150px] text-center">
                                          un moment sucré dans notre pâtisserie exquise
                                        </p>
                                    </div>
                                    
                                  </Slide>
                                  <Slide index={4}>
                                    <div className="flex flex-col items-center">
                                        <div className="flex flex-shrink-0 relative w-full sm:w-auto mt-3">
                                          <img className="w-[150px] bg-[#cecece] p-5" src={cafe} alt="café" />
                                        </div>
                                        <p className="text-[#FCCA46] font-semibold text-lg text-center pt-3">
                                          Cafétéria
                                        </p>
                                        <p className="w-[150px] text-center">
                                          l'arôme envoûtant du café fraîchement moulu
                                        </p>
                                    </div>
                                    
                                  </Slide>
                                  <Slide index={5}>
                                    <div className="flex flex-col items-center">
                                        <div className="flex flex-shrink-0 relative w-full sm:w-auto mt-3">
                                          <img className="w-[150px] bg-[#cecece] p-5" src={resto} alt="café" />
                                        </div>
                                        <p className="text-[#FCCA46] font-semibold text-lg text-center pt-3">
                                          Restaurant
                                        </p>
                                        <p className="w-[150px] text-center">
                                          une expérience culinaire d'exception dans des restaurants
                                        </p>
                                    </div>
                                    
                                  </Slide>
                                </div>
                              </Slider>
                            </div>
                            <ButtonNext
                              role="button"
                              aria-label="slide forward"
                              className="absolute z-30 right-0 mr-8 focus:outline-none focus:bg-gray-400 focus:ring-2 focus:ring-offset-2 focus:ring-gray-400"
                              id="next"
                            >
                              <svg
                                width={8}
                                height={14}
                                viewBox="0 0 8 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M1 1L7 7L1 13"
                                  stroke="white"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </ButtonNext>
                          </div>
                     </CarouselProvider>

                      {/* Carousel for tablet and medium size devices */}
                    <CarouselProvider className="md:hidden xs:block hidden" 
                                      naturalSlideWidth={100} 
                                      naturalSlideHeight={100}
                                      isIntrinsicHeight={true} 
                                      totalSlides={6} 
                                      visibleSlides={2} 
                                      step={1} 
                                      infinite={true}
                                      isPlaying={true} // Active l'auto-slide
                                      interval={3000}
                                      >
                                  <div className="w-full relative flex items-center justify-center">
                                    <ButtonBack role="button" aria-label="slide backward" className="absolute z-30 left-0 ml-8 focus:outline-none focus:bg-gray-400 focus:ring-2 focus:ring-offset-2 focus:ring-gray-400 cursor-pointer" id="prev">
                                      <svg width={8} height={14} viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M7 1L1 7L7 13" stroke="white" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
                                      </svg>
                                    </ButtonBack>
                                    <div className="w-full h-full mx-auto overflow-x-hidden overflow-y-hidden">
                                      <Slider>
                                          <div id="slider" className="h-full flex lg:gap-8 md:gap-6 gap-14 items-center justify-start transition ease-out duration-700">
                                              <Slide index={0}>
                                                <div className="flex flex-col items-center">
                                                    <div className="flex flex-shrink-0 relative w-full sm:w-auto mt-3">
                                                      <img className="w-[150px] bg-[#cecece] p-5" src={cafe} alt="café" />
                                                    </div>
                                                    <p className="text-[#FCCA46] font-semibold text-lg text-center pt-3">
                                                      Cafétéria
                                                    </p>
                                                    <p className="w-[150px] text-center">
                                                      L'arôme envoûtant du café fraîchement moulu
                                                    </p>
                                              </div>
                                            
                                          </Slide>
                                          <Slide index={1}>
                                              <div className="flex flex-col items-center">
                                                  <div className="flex flex-shrink-0 relative w-full sm:w-auto mt-3">
                                                    <img className="w-[150px] bg-[#cecece] p-5" src={resto} alt="café" />
                                                  </div>
                                                  <p className="text-[#FCCA46] font-semibold text-lg text-center pt-3">
                                                      Restaurant 
                                                  </p>
                                                  <p className="w-[150px] text-center">
                                                    une expérience culinaire d'exception dans des restaurants
                                                  </p>
                                            </div>
                                           
                                          </Slide>
                                          <Slide index={2}>
                                            <div className="flex flex-col items-center">
                                                <div className="flex flex-shrink-0 relative w-full sm:w-auto mt-3">
                                                  <img className="w-[150px] bg-[#cecece] p-5" src={pizza} alt="café" />
                                                </div>
                                                <p className="text-[#FCCA46] font-semibold text-lg text-center pt-3">
                                                    Pizzeria 
                                                </p>
                                                <p className="w-[150px] text-center">
                                                    déguster des pizzas exquises
                                                </p>
                                            </div>
                                           
                                          </Slide>
                                          <Slide index={3}>
                                          <div className="flex flex-col items-center">
                                              <div className="flex flex-shrink-0 relative w-full sm:w-auto mt-3">
                                                <img className="w-[150px] bg-[#cecece] p-5" src={patisserie} alt="café" />
                                              </div>
                                              <p className="text-[#FCCA46] font-semibold text-lg text-center pt-3">
                                                  Patisserie
                                              </p>
                                              <p className="w-[150px] text-center">
                                                un moment sucré dans notre pâtisserie exquise
                                              </p>
                                          </div>
                                          
                                          </Slide>
                                          <Slide index={4}>
                                              <div className="flex flex-col items-center">
                                                <div className="flex flex-shrink-0 relative w-full sm:w-auto mt-3">
                                                  <img className="w-[150px] bg-[#cecece] p-5" src={bar} alt="café" />
                                                </div>
                                                <p className="text-[#FCCA46] font-semibold text-lg text-center pt-3">
                                                    Bar
                                                </p>
                                                <p className="w-[150px] text-center">
                                                  des instants festifs au cœur de notre bar. Cheers
                                                </p>
                                            </div>
                                           
                                          </Slide>
                                          <Slide index={5}>
                                          <div className="flex flex-col items-center">
                                              <div className="flex flex-shrink-0 relative w-full sm:w-auto mt-3">
                                                <img className="w-[150px] bg-[#cecece] p-5" src={resto} alt="café" />
                                              </div>
                                              <p className="text-[#FCCA46] font-semibold text-lg text-center pt-3">
                                                Restaurant
                                              </p>
                                              <p className="w-[150px] text-center">
                                                une expérience culinaire d'exception dans des restaurants
                                              </p>
                                          </div>
                                           
                                          </Slide>
                                          <Slide index={0}>
                                              <div className="flex flex-col items-center">
                                                    <div className="flex flex-shrink-0 relative w-full sm:w-auto mt-3">
                                                      <img className="w-[150px] bg-[#cecece] p-5" src={cafe} alt="café" />
                                                    </div>
                                                    <p className="text-[#FCCA46] font-semibold text-lg text-center pt-3">
                                                      Cafétéria
                                                    </p>
                                                    <p className="w-[150px] text-center">
                                                      L'arôme envoûtant du café fraîchement moulu
                                                    </p>
                                              </div>
                                          </Slide>
                                          <Slide index={1}>
                                            <div className="flex flex-col items-center">
                                                <div className="flex flex-shrink-0 relative w-full sm:w-auto mt-3">
                                                  <img className="w-[150px] bg-[#cecece] p-5" src={resto} alt="café" />
                                                </div>
                                                <p className="text-[#FCCA46] font-semibold text-lg text-center pt-3">
                                                    Restaurant 
                                                </p>
                                                <p className="w-[150px] text-center">
                                                  une expérience culinaire d'exception dans des restaurants
                                                </p>
                                            </div>
                                          
                                          </Slide>
                                          <Slide index={2}>
                                            <div className="flex flex-col items-center">
                                                <div className="flex flex-shrink-0 relative w-full sm:w-auto mt-3">
                                                  <img className="w-[150px] bg-[#cecece] p-5" src={pizza} alt="café" />
                                                </div>
                                                <p className="text-[#FCCA46] font-semibold text-lg text-center pt-3">
                                                    Pizzeria 
                                                </p>
                                                <p className="w-[150px] text-center">
                                                    déguster des pizzas exquises
                                                </p>
                                            </div>
                                          </Slide>
                                          <Slide index={3}>
                                          <div className="flex flex-col items-center">
                                              <div className="flex flex-shrink-0 relative w-full sm:w-auto mt-3">
                                                <img className="w-[150px] bg-[#cecece] p-5" src={patisserie} alt="café" />
                                              </div>
                                              <p className="text-[#FCCA46] font-semibold text-lg text-center pt-3">
                                                  Patisserie
                                              </p>
                                              <p className="w-[150px] text-center">
                                                un moment sucré dans notre pâtisserie exquise
                                              </p>
                                          </div>
                                          </Slide>
                                          <Slide index={4}>
                                            <div className="flex flex-col items-center">
                                                <div className="flex flex-shrink-0 relative w-full sm:w-auto mt-3">
                                                  <img className="w-[150px] bg-[#cecece] p-5" src={bar} alt="café" />
                                                </div>
                                                <p className="text-[#FCCA46] font-semibold text-lg text-center pt-3">
                                                    Bar
                                                </p>
                                                <p className="w-[150px] text-center">
                                                  des instants festifs au cœur de notre bar. Cheers
                                                </p>
                                            </div>
                                          </Slide>
                                          <Slide index={5}>
                                              <div className="flex flex-col items-center">
                                                    <div className="flex flex-shrink-0 relative w-full sm:w-auto mt-3">
                                                      <img className="w-[150px] bg-[#cecece] p-5" src={cafe} alt="café" />
                                                    </div>
                                                    <p className="text-[#FCCA46] font-semibold text-lg text-center pt-3">
                                                      Cafétéria
                                                    </p>
                                                    <p className="w-[150px] text-center">
                                                      L'arôme envoûtant du café fraîchement moulu
                                                    </p>
                                              </div>
                                          </Slide>
                                        </div>
                                      </Slider>
                                    </div>
                                    <ButtonNext role="button" aria-label="slide forward" className="absolute z-30 right-0 mr-8 focus:outline-none focus:bg-gray-400 focus:ring-2 focus:ring-offset-2 focus:ring-gray-400" id="next">
                                      <svg width={8} height={14} viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1 1L7 7L1 13" stroke="white" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
                                      </svg>
                                    </ButtonNext>
                                  </div>
                    </CarouselProvider>


                     {/* Carousel for mobile and Small size Devices */}
                      <CarouselProvider className="block xs:hidden " 
                                        naturalSlideWidth={100} 
                                        naturalSlideHeight={100}
                                        isIntrinsicHeight={true} 
                                        totalSlides={6} 
                                        visibleSlides={1} 
                                        step={1} 
                                        infinite={true}
                                        isPlaying={true} // Active l'auto-slide
                                        interval={3000}
                                        >
                        <div className="w-full relative flex items-center justify-center">
                          <ButtonBack role="button" aria-label="slide backward" className="absolute z-30 left-0 ml-8 focus:outline-none focus:bg-gray-400 focus:ring-2 focus:ring-offset-2 focus:ring-gray-400 cursor-pointer" id="prev">
                            <svg width={8} height={14} viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M7 1L1 7L7 13" stroke="white" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          </ButtonBack>
                          <div className="w-full h-full mx-auto overflow-x-hidden overflow-y-hidden">
                            <Slider>
                              <div id="slider" className="h-full w-full flex lg:gap-8 md:gap-6 items-center justify-start transition ease-out duration-700">
                                
                              <Slide index={0}>
                                  <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                                      <div className="flex flex-col items-center">
                                        <div className="flex flex-shrink-0 relative w-full sm:w-auto mt-3">
                                          <img
                                            className="w-full max-w-screen-xl px-4 bg-[#cecece] p-5 ml-32 mr-32"
                                            src={cafe}
                                            alt="restaurant"
                                          />
                                        </div>
                                        <p className="text-[#FCCA46] font-semibold text-lg text-center pt-3">
                                          Cafétéria
                                        </p>
                                        <p className="max-w-md text-center px-4">
                                          L'arôme envoûtant du café fraîchement moulu
                                        </p>
                                      </div>
                                  </div>
                                </Slide>
                                <Slide index={1}>
                                  <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                                      <div className="flex flex-col items-center">
                                        <div className="flex flex-shrink-0 relative w-full sm:w-auto mt-3">
                                          <img
                                            className="w-full max-w-screen-xl px-4 bg-[#cecece] p-5 ml-32 mr-32"
                                            src={resto}
                                            alt="restaurant"
                                          />
                                        </div>
                                        <p className="text-[#FCCA46] font-semibold text-lg text-center pt-3">
                                          Restaurant
                                        </p>
                                        <p className="w-[150px] text-center">
                                          Une expérience culinaire d'exception dans des restaurants
                                        </p>
                                      </div>
                                  </div>
                                </Slide>
                                <Slide index={2}>
                                  <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                                    <div className="flex flex-col items-center">
                                        <div className="flex flex-shrink-0 relative w-full sm:w-auto mt-3">
                                          <img
                                            className="w-full max-w-screen-xl px-4 bg-[#cecece] p-5 ml-32 mr-32"
                                            src={pizza}
                                            alt="pizza"
                                          />
                                        </div>
                                        <p className="text-[#FCCA46] font-semibold text-lg text-center pt-3">
                                          Pizzeria
                                        </p>
                                        <p className="w-[150px] text-center">
                                          Déguster des pizzas exquises
                                        </p>
                                    </div>
                                  </div>
                                </Slide>
                                <Slide index={3}>
                                  <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                                      <div className="flex flex-col items-center">
                                        <div className="flex flex-shrink-0 relative w-full sm:w-auto mt-3">
                                          <img
                                            className="w-full max-w-screen-xl px-4 bg-[#cecece] p-5 ml-32 mr-32"
                                            src={bar}
                                            alt="bar"
                                          />
                                        </div>
                                        <p className="text-[#FCCA46] font-semibold text-lg text-center pt-3">
                                          Bar
                                        </p>
                                        <p className="w-[150px] text-center">
                                          Des instants festifs au cœur de notre bar. Cheers !
                                        </p>
                                      </div>
                                  </div>
                                </Slide>
                                <Slide index={4}>
                                  <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                                    <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                                      <div className="flex flex-col items-center">
                                          <div className="flex flex-shrink-0 relative w-full sm:w-auto mt-3">
                                            <img
                                              className="w-full max-w-screen-xl px-4 bg-[#cecece] p-5 ml-32 mr-32"
                                              src={cafe}
                                              alt="restaurant"
                                            />
                                          </div>
                                          <p className="text-[#FCCA46] font-semibold text-lg text-center pt-3">
                                            Cafétéria
                                          </p>
                                          <p className="max-w-md text-center px-4">
                                            L'arôme envoûtant du café fraîchement moulu
                                          </p>
                                      </div>
                                    </div>
                                  </div>
                                </Slide>
                                <Slide index={5}>
                                  <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                                    <div className="flex flex-col items-center">
                                        <div className="flex flex-shrink-0 relative w-full sm:w-auto mt-3">
                                          <img
                                            className="w-full max-w-screen-xl px-4 bg-[#cecece] p-5 ml-32 mr-32"
                                            src={pizza}
                                            alt="pizza"
                                          />
                                        </div>
                                        <p className="text-[#FCCA46] font-semibold text-lg text-center pt-3">
                                          Pizzeria
                                        </p>
                                        <p className="w-[150px] text-center">
                                          Déguster des pizzas exquises
                                        </p>
                                    </div>
                                  </div>
                                </Slide>
              
                              </div>
                            </Slider>
                          </div>
                          <ButtonNext role="button" aria-label="slide forward" className="absolute z-30 right-0 mr-8 focus:outline-none focus:bg-gray-400 focus:ring-2 focus:ring-offset-2 focus:ring-gray-400" id="next">
                            <svg width={8} height={14} viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M1 1L7 7L1 13" stroke="white" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          </ButtonNext>
                        </div>
                      </CarouselProvider>                 
               </div>
          </div>

           {/* barre bleu */}
            <div className='grid w-2/3 my-16 border-t-4 border-slate-900'></div>

             {/* title */}
            <div className='flex flex-col items-center justify-center my-10 space-y-5 '>
                <p className='font-semibold text-center xs:text-2xl s:text-xl'> {t("RESTAURATIONS")}</p>
                <p className='text-center s:w-[260px] sm:w-[340px] md:w-[850px] xs:w-[600px] text-lg'>
                Savourez l'excellence culinaire en Côte d'Ivoire ! Découvrez une fusion de saveurs 
                authentiques, de plats traditionnels et de créations innovantes. Faites de votre repas 
                une aventure mémorable.
                </p>
            </div>

             {/* filtre */}
            <div className='grid pt-10 md:grid-cols-4 xs:grid-cols-3 s:gap-6 md:gap-0 s:grid-cols-1 place-items-center'>
              <button className='w-[200px] h-10 bg-[#233D4D] text-lg text-white rounded hover:bg-white hover:text-[#233D4D] transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300'
              onClick={() => {
                setStar('');
                setLieu('');
                setPrix('');
              }}
              >{t("Tout")}</button>
              {/* etoiles*/}
              <select className='border-[#233D4D] border-2 w-[200px] px-3 h-10 rounded text-lg'
                value={star}
                onChange={(e) => setStar(e.target.value)}
              >
                <option>5 {t("étoiles")}</option>
                <option>4 {t("étoiles")}</option>
                <option>3 {t("étoiles")}</option>
                <option>2 {t("étoiles")}</option>
              </select>
              {/* Lieu ou la voiture se trouve */}
              <input type='text' name='lieu_voiture' placeholder={t('Ville ou commune')} className='border-[#233D4D] border-2 w-[200px] px-3 h-10 rounded text-lg'
                onChange={(e) => setLieu(e.target.value)}
              />
              {/* prix de la voiture */}
              <input type='text' name='lieu_voiture' placeholder={t('Prix')} className='border-[#233D4D] border-2 w-[200px] px-3 h-10 rounded text-lg' 
                onChange={(e) => setPrix(e.target.value)}
              />
            </div>

            {/* container restaurant */}
           <div className='flex flex-wrap justify-center my-20 md:flex-row s:flex-col s:items-center md:items-start s:space-y-10 md:space-y-0'>

                {filteredResto.map((list, index )=> (
                    <div key={index} className=' flex flex-col space-y-8 border-l-2 my-3 border-[#fe7f2d] pl-5'>

                        {/* restaurant1 */}
                        <div className='flex space-x-6 space-y-5 xs:flex-row s:flex-col '>
                            <img className=' rounded-full w-[180px] h-[180px] border-4 border-yellow-400 shadow-xl' src={`data:image/png;base64,${list[0]}`} alt={list.title_announce}/>
                            {/* Description */}
                            <div>
                                <p className='uppercase text-lg font-semibold text-[#FE7F2D] pb-3'>{list.title_announce}</p>
                                <p className='text-[#233D4D]font-medium pb-2'>{ truncateAdress(list.contact_address) }</p>
                                <p className='xs:w-[350px] s:w-[200px] sm:w-[300px]'>{truncate(list.description_announce)}
                                </p>
                                <div className='flex flex-row space-x-4'>
                                  <Link to="/restaurants/Voir_Plus/#voir-plus" state={list.id_announce}>
                                      <button className='flex items-center h-8 px-5 my-3 space-x-2 text-white rounded bg-slate-800 hover:bg-white hover:border-2 hover:border-slate-800 hover:text-slate-800'>
                                          <p>{t("Visiter")}</p>
                                          <VscEye className='text-lg' />
                                      </button>
                                  </Link>
                                  
                                  {list.status === "enabled" && authUser && authUser.userId !== list?.made_by && (
                                      <Link to="/Reservation_Restaurant" state={list.id_announce}>
                                          <button className='flex items-center h-8 px-5 my-3 space-x-2 text-white rounded bg-slate-800 hover:bg-white hover:border-2 hover:border-slate-800 hover:text-slate-800'>
                                              {t("Reserver")}
                                          </button>
                                      </Link>
                                  )}
                              </div>

                            </div>
                        </div>

                    </div>
                    )
                    )}
           </div>

           <Barniere/>

            <Footer/>
        </>
      )}
    </div>
  )
}

export default Restaurant